module.exports = __webpack_public_path__ + "assets/classrooms_info_icon.da16612b.svg";